import {createStore, applyMiddleware, compose} from 'redux'
import rootReducer from '../redux/reducers/rootReducer'
import thunk from 'redux-thunk'
import reduxReset from 'redux-reset'

export default () => {
	let store = createStore(
		rootReducer,
		window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
		compose(
			reduxReset(),
			applyMiddleware(thunk)
		)
	)
	return { store }
}



// WEBPACK FOOTER //
// ./src/store/store.js